/**
 * 图标
 * @type {{SUCCESS, ERROR}}
 */
export const DIALOG_ICONS = {
  SUCCESS: require('@/assets/dialog/完成@3x.png'),
  ERROR: require('@/assets/dialog/警示.png')
}



// WEBPACK FOOTER //
// ./src/plugins/dialog/config.js